import { Trash2 } from "lucide-react";
import type { FC } from "react";
import { AdvisorConfirmAction } from "web_myplann/Advisor/Components/AdvisorConfirmAction";
import { useDeleteAdvisor } from "web_myplann/Advisor/Hooks/useDeleteAdvisor";
import { getAdvisorDeleteConfirmCopy } from "web_myplann/Advisor/Utils/getAdvisorDeleteConfirmCopy";
import {
	type AgentAssignedListItemResponseDTO,
	UserTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { Resources } from "web_myplann/Infrastructure/Translations/Resources";

const R = Resources.Advisor;

type Props = {
	advisor?: AgentAssignedListItemResponseDTO;
	onDeleted: () => void;
};

export const AdvisorDeleteAction: FC<Props> = ({ advisor, onDeleted }) => {
	const { canDelete, hasSharedData, isPending, confirmDelete } =
		useDeleteAdvisor(advisor, onDeleted);
	const copy = getAdvisorDeleteConfirmCopy({
		isAssistant: advisor?.type === UserTypeEnum.Assistant,
		hasSharedData,
	});

	return (
		<AdvisorConfirmAction
			advisor={advisor}
			visible={canDelete}
			icon={Trash2}
			ariaLabel={R.deleteAria}
			copy={copy}
			isPending={isPending}
			onConfirm={confirmDelete}
		/>
	);
};
